import React from 'react';
import Button, {ButtonProps} from '@material-ui/core/Button';
import theme from '../../theme';
import MenuItemAnchor, {MenuItemAnchorProps} from './MenuItemAnchor';
import useSyncPromise from '../../utils/react/useSyncPromise';
import fetchUser from '../../utils/gaia/fetchUser';
import gettext from '../../utils/django/gettext';

function useIsVisible() {
    const [user,, isLoaded] = useSyncPromise(fetchUser());
    return isLoaded ? !user.isAuthenticated : false;
}

const sharedProps = {
    href: `/login/?next=${window.location.pathname}`,
    children: gettext('Log In')
};

function Toolbar({style, ...props}: ButtonProps) {
    if (!useIsVisible()) return null;

    return <Button
        {...props}
        {...sharedProps}
        style={{...style, color: theme.palette.primary.main}}
        color="primary"
        variant="outlined"
    />;
}

function HamburgerMenu(props: MenuItemAnchorProps) {
    if (!useIsVisible()) return null;
    return <MenuItemAnchor {...props} {...sharedProps} />;
}

export default {Toolbar, HamburgerMenu};
